import { useState, type FormEvent } from "react";
import { login, type Session } from "./auth";

/** Pagina di accesso: username e password degli account della rubrica (stessi nomi di Predimain, password locale). */
export default function Login({ onLogin, notice }: { onLogin: (s: Session) => void; notice?: string }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!username.trim() || !password) { setError("Inserisci username e password"); return; }
    setBusy(true);
    setError(null);
    try {
      onLogin(await login(username.trim(), password));
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <h1>MDT Assistenza remota</h1>
        <p className="login-sub">Accesso esperto</p>
        {notice && <p className="login-notice">{notice}</p>}
        <label>Username
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" autoFocus disabled={busy} />
        </label>
        <label>Password
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" disabled={busy} />
        </label>
        {error && <p className="login-error">{error}</p>}
        <button className="primary" type="submit" disabled={busy}>{busy ? "Accesso…" : "Entra"}</button>
      </form>
    </div>
  );
}
